module.exports = __webpack_public_path__ + "img/39a91401b7f72c67ed8ad668b3a10a3a.png";